import { render, staticRenderFns } from "./authDetail.vue?vue&type=template&id=4a040262&scoped=true&"
import script from "./authDetail.vue?vue&type=script&lang=js&"
export * from "./authDetail.vue?vue&type=script&lang=js&"
import style0 from "./authDetail.vue?vue&type=style&index=0&id=4a040262&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a040262",
  null
  
)

export default component.exports